import * as React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IReport } from '../../../common/sharedTypes';

interface CompletedIndicatorProps {
  completedDate?: Date;
}

function CompletedIndicator({ completedDate }: CompletedIndicatorProps) {
  return (
    <>{' '}
      {completedDate &&
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip
              id='tooltip-merged-indicator-top'
            >
              Previously Completed
            </Tooltip>
          }
        >
          <i className="fa fa-flag-checkered" aria-hidden="true"></i>
        </OverlayTrigger>
      }
    </>
  )
}

export default CompletedIndicator;